import * as Sentry from "@sentry/angular";
import { ApplicationConfig, ErrorHandler, provideAppInitializer, inject, provideZonelessChangeDetection } from '@angular/core';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, withFetch} from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading, Router, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import {NgcCookieConsentConfig, provideNgcCookieConsent} from 'ngx-cookieconsent';

const cookieConfig: NgcCookieConsentConfig = {
      cookie: {
        domain: environment.url
      },
      palette: {
        popup: {
          background: '#7a961a',
          text: '#fff'
        },
        button: {
          background: '#249546',
          text: '#fff',
        }
      },
      position: 'bottom-left',
      theme: 'classic',
      type: 'opt-out',
      content: {
        link: '',
        deny: 'Decline'
      }
    }

export const appConfig: ApplicationConfig = {
    providers: [
      provideZonelessChangeDetection(),
      provideHttpClient(withFetch()),
      provideRouter(routes,withPreloading(PreloadAllModules),withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: "enabled"
      }),),
      provideTranslateService({
          extend: true,
          loader: provideTranslateHttpLoader({
              prefix: '/assets/i18n/',
              suffix: '.json',
          }),
        fallbackLang: 'ar',
      }),
      provideClientHydration(withEventReplay()),
      provideNgcCookieConsent(cookieConfig),
      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler()
      },
      {
        provide: Sentry.TraceService,
        deps: [Router]
      },
      provideAppInitializer(() => {
        inject(Sentry.TraceService);
      })
    ]
}